var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckboxCheckedPurpleMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_1456",
    "data-name": "Group 1456",
    transform: "translate(-150 -228)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Component_87_1",
    "data-name": "Component 87 \\u2013 1",
    transform: "translate(150 228)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Rectangle_100",
    fill: "#fff",
    stroke: "#2e2d79",
    "data-name": "Rectangle 100"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0H18V18H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0.5 0.5H17.5V17.5H0.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Component_86_1",
    "data-name": "Component 86 \\u2013 1",
    transform: "translate(155.136 233.695)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6504",
    fill: "none",
    stroke: "#2e2d79",
    strokeLinecap: "square",
    strokeWidth: "1.5px",
    d: "M8.587 1.175L3.219 7.99.083 5.1",
    "data-name": "Path 6504",
    transform: "translate(-.083 -1.175)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxCheckedPurpleMobile);
export default __webpack_public_path__ + "static/media/checkbox-checked-purple-mobile.c0ed8c4cc1285b671da29e84566c1f4b.svg";
export { ForwardRef as ReactComponent };